const PLACEHOLDER_PATTERN = /^(\[[A-Za-z0-9_]+\])$/;

type KbSectionContentPreviewProps = {
  readonly content: string;
  readonly className?: string;
};

export const KbSectionContentPreview = ({ content, className }: KbSectionContentPreviewProps) => {
  const parts = content.split(/(\[[A-Za-z0-9_]+\])/g);

  return (
    <div
      className={
        className ??
        "whitespace-pre-wrap text-sm leading-relaxed text-gray-800"
      }
    >
      {parts.map((part, index) =>
        PLACEHOLDER_PATTERN.test(part) ? (
          <mark
            key={`${index}-${part}`}
            className="rounded border border-amber-200 bg-amber-100 px-1 py-0.5 font-mono text-xs font-semibold text-amber-900"
          >
            {part}
          </mark>
        ) : (
          <span key={`${index}-text`}>{part}</span>
        ),
      )}
    </div>
  );
};
